import { useMutation } from '@tanstack/react-query'

import { createOnboardingTips, destroyAllOnboardingTips } from './api'
import { invalidateOnboardingTipsQuery } from './invalidators'
import { addNewUserTipsQueryClient } from './setters'

export const useCreateOnboardingTipsMutation = () =>
  useMutation({
    mutationFn: createOnboardingTips,
    onSuccess: addNewUserTipsQueryClient,
  })

export const useDestroyAllOnboardingTipsMutation = () =>
  useMutation({
    mutationFn: destroyAllOnboardingTips,
    onSuccess: invalidateOnboardingTipsQuery,
  })
